var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.hasHeader)?_c('Header'):_vm._e(),_c('section',{staticClass:"section"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }